export const isValidToRender = (disclaimerName, hideFinancingTable, hideCalculationDisclaimer) => !((disclaimerName === 'productDisclaimer' && hideFinancingTable) ||
    (disclaimerName === 'calculationDisclaimer' && hideCalculationDisclaimer));
export const getFeatureAppNames = (appContext) => {
    if (appContext === 'suggested') {
        return {
            eventName: 'vtp suggested cars',
            componentName: 'vtp-suggested-cars',
        };
    }
    return {
        eventName: 'vtp results',
        componentName: 'vtp-results',
    };
};
